import Swiper, { Navigation, Lazy } from 'swiper';
Swiper.use([Navigation, Lazy]);

export default function setBenefits() {
  const section = document.querySelector('.benefits');
  const swiper = section.querySelector('.swiper'),
    prev = section.querySelector('.swiper-button-prev'),
    next = section.querySelector('.swiper-button-next');
  new Swiper(swiper, {
    slidesPerView: 1,
    spaceBetween: 0,
    preloadImages: false,
    speed: 1000,
    lazy: {
      checkInView: true,
      loadPrevNext: true,
      loadOnTransitionStart: true,
      loadPrevNextAmount: 3,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: next,
      prevEl: prev,
      disabledClass: '-disabled',
    },
  });
}
